// extracted by mini-css-extract-plugin
export default {"cta":"OI-z","disabled":"PI-z"};